export const Hrandom = function (min, max) {
  return min + Math.random() * (max - min);
};

export const HrandomChoice = function (choices) {
  return choices[Math.round(Hrandom(0, choices.length - 1))];
};
